import { waLink, WHATSAPP_INTENTS } from "../config";

export default function FinalCTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20Turkish%20home%20cooking%20feast%20on%20long%20wooden%20table%20with%20many%20dishes%20rice%20soup%20salad%20bread%20and%20colorful%20bowls%2C%20steam%20rising%2C%20warm%20golden%20natural%20light%2C%20dark%20moody%20background%2C%20editorial%20food%20photography%2C%20appetizing%20authentic%20Turkish%20cuisine&width=1600&height=900&seq=final-sofra&orientation=landscape"
          alt="Meliha Sultan zengin ev yemeği sofrası"
          title="Meliha Sultan Ev Yemekleri - sofra"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative mx-auto max-w-4xl px-4 md:px-6 text-center text-background-50">
        <h2 className="font-heading text-4xl md:text-6xl font-bold leading-tight">
          BUGÜN NE YİYECEĞİNE
          <br />
          BAŞKASI KARAR VERMESİN.
        </h2>
        <p className="mt-5 text-base md:text-lg text-background-50/85">
          Menünü seç, günlük hazırlayalım, sofrana ulaştıralım.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#menu"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            MENÜMÜ OLUŞTUR
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href={waLink(WHATSAPP_INTENTS.hero)}
            target="_blank"
            rel="nofollow noopener"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md bg-background-50 text-foreground-950 text-base font-bold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WHATSAPP'TAN BİLGİ AL
          </a>
        </div>
      </div>
    </section>
  );
}